import React, { useState, useEffect } from 'react';
import { Car, Plane, Map, Star, Mountain, Hospital } from 'lucide-react';
import { api, fallbackData } from '../data/api';

const iconMap = {
  car: Car,
  plane: Plane,
  map: Map,
  star: Star,
  mountain: Mountain,
  hospital: Hospital
};

const ServicesSection = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await api.getServices();
        if (data && data.length > 0) {
          setServices(data);
        } else {
          setServices(fallbackData.services);
        }
      } catch (error) {
        setServices(fallbackData.services);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  return (
    <section id="services" className="py-20 md:py-28 bg-zinc-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-amber-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-amber-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-400 text-sm font-semibold tracking-wider uppercase mb-4">
            Hizmetlerimiz
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Denizli Taksi <span className="text-amber-400">Hizmetleri</span>
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            Şehir içi ulaşımdan havalimanı transferine, Pamukkale turlarından şehirlerarası 
            yolculuklara kadar tüm taksi ihtiyaçlarınız için yanınızdayız.
          </p>
        </div>

        {/* Services Grid */}
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="bg-zinc-800/50 rounded-2xl p-6 md:p-8 border border-zinc-700/50 animate-pulse">
                <div className="w-14 h-14 bg-zinc-700 rounded-xl mb-6"></div>
                <div className="h-6 bg-zinc-700 rounded mb-3 w-3/4"></div>
                <div className="h-4 bg-zinc-700 rounded w-full"></div>
                <div className="h-4 bg-zinc-700 rounded w-2/3 mt-2"></div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, index) => {
              const IconComponent = iconMap[service.icon] || Car;
              return (
                <div
                  key={service.id}
                  className="group bg-zinc-800/50 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-zinc-700/50 hover:border-amber-500/50 transition-all duration-500 hover:shadow-xl hover:shadow-amber-500/10 hover:-translate-y-1"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center mb-6 shadow-lg shadow-amber-500/30 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-7 h-7 text-zinc-900" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-zinc-400 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              );
            })}
          </div>
        )}

        {/* SEO Rich Text */}
        <div className="mt-16 text-center">
          <p className="text-zinc-500 text-sm max-w-3xl mx-auto">
            TaksiBond olarak Denizli ve çevresinde 7/24 taksi hizmeti sunuyoruz. 
            Denizli havalimanı transfer, Pamukkale turları, hastane transferi ve şehirlerarası 
            taksi hizmetlerimizle her zaman yanınızdayız.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
